export default __webpack_public_path__ + "static/media/Usuario.2d25b661.svg";